
export { useProductsSalableQuantityLazyQuery } from "/opt/atlassian/pipelines/agent/build/packages/modules/module-catalog/src/types/front.graphql.ts"